import { createContext, useContext } from "react";
import { TrapsiteEditorApi } from "./types";

/**
 * Null when the map is not editable, which is the default for the specimen and
 * location-detail maps. Consumers check `enabled` rather than branching on the
 * context being present, so the hook is always safe to call.
 */
const noop = () => {};

const DISABLED: TrapsiteEditorApi = {
  enabled: false,
  target: null,
  mode: null,
  editingId: null,
  draft: null,
  deviceDraft: null,
  staged: { devices: {}, trapSites: {} },
  menu: null,
  openMenu: noop,
  closeMenu: noop,
  startCreate: noop,
  startEdit: noop,
  patchDraft: noop,
  startMoveTrap: noop,
  startEditTrap: noop,
  patchDeviceDraft: noop,
  selectDevice: noop,
  movePinTo: noop,
  stageDeviceMove: noop,
  stageTrapSiteMove: noop,
  close: noop,
};

export const TrapsiteEditorContext = createContext<TrapsiteEditorApi>(DISABLED);

export const useTrapsiteEditorContext = (): TrapsiteEditorApi =>
  useContext(TrapsiteEditorContext);
